import { NODE_BACK_URL, PROXY_CORE_PATH } from '../endpoints';

export const ACCOUNT_PERMISSIONS_URL = `${NODE_BACK_URL}${PROXY_CORE_PATH}v2.0/user_accounts`;

export const getUpdateAccountPermissionEndpoint = (userAccountId: string) =>
  `${NODE_BACK_URL}${PROXY_CORE_PATH}v2.0/user_accounts/${userAccountId}`;

export const getUpdateAtpPermissionsEndpoint = (userId: string) =>
  `${NODE_BACK_URL}${PROXY_CORE_PATH}v2.0/users/${userId}/permissions/atp`;
